import React, { ReactChild, HTMLAttributes } from 'react'

export interface ITableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  children: ReactChild | ReactChild[];
}

export default function TableBody({children, ...props}: ITableBodyProps) {
  return (
    <tbody {...props}>
      {children}
    </tbody>
  )
}
